// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ae4086256f9412539dd3","293":"20adb4646538e144e5d7","518":"98ded39b2ebdcbbb368e","779":"fec387a34797e9fdbfcf"}[chunkId] + ".js";
};